
// stored in the db, don't remove any values or change existing values
export enum LobbyImage {
    Pencil = 0,
    Bot = 1,
    CheckMark = 2,
    XMark = 3,
    Logo = 4,
    Lightning = 5,
    Plus = 6,
    PlusStore = 7,
    Mail = 8,
    Admin = 9,
    Moderator = 10,
    User = 11,
    Guest = 12,
    Star = 13,
    Players = 14,
    PlayersRanked = 285,
    ReplayIcon = 15,
    QuestionMark = 16,
    InfoIcon = 17,
    DangerIcon = 18,
    KarmaWhite = 19,
    KarmaRed = 20,
    KarmaOrange = 21,
    KarmaGreen = 22,
    DisableAdBlock = 23,
    ColonistCoin = 24,
    Rulebook = 25,
    BankIcon = 26,
    FullScreenExpand = 27,
    FullScreenContract = 28,
    FullScreenGif = 29,
    LeftArrow = 30,
    Audio = 31,
    Eye = 32,
    SendArrow = 33,
    Settings = 34,
    Chat = 35,
    Log = 36,
    MatchmakingSearch = 37,
    Lock = 38,
    LockOutlined = 39,
    LockSlanted = 40,
    LockOn = 288,
    Share = 41,
    NoAds = 246,
    Colors = 247,
    Avatars = 261,
    Maps = 262,
    Expansions = 263,
    AllColors = 264,
    Memberships = 267,

    RoadBronze = 42,
    SettlementBronze = 43,
    CityBronze = 44,

    // Maps
    MapDiamondPreview = 45,
    MapLakesPreview = 46,
    MapPondPreview = 47,
    MapGearPreview = 48,
    MapUSAPreview = 49,
    MapTwirlPreview = 50,
    MapEarthPreview = 51,
    MapUKPreview = 52,
    MapCyclopsPreview = 53,
    MapClassic4PPreview = 54,
    MapClassic56PPreview = 55,
    MapClassic78PPreview = 56,
    MapPangaeaPreview = 57,
    MapSpinnerPreview = 58,
    MapRandomBasePreview = 59,
    MapRomaniaPreview = 60,
    MapHourglassPreview = 61,
    MapHourglassXLPreview = 62,
    MapSnowflakePreview = 63,
    MapShuffleBoardPreview = 64,
    MapMiniBasePreview = 65,
    MapAustraliaPreview = 66,
    MapDuelPreview = 67,
    MapMonopolyPreview = 68,
    MapKingOfTheHillPreview = 69,
    MapMountainOfRichesPreview = 70,
    MapDoggoPreview = 71,
    MapTradeIslandsPreview = 72,
    MapTurningTidesPreview = 73,
    MapBlackForestPreview = 74,
    MapVolcanoPreview = 75,
    MapCirclePreview = 76,
    MapKitePreview = 77,
    MapVietnamPreview = 78,
    MapTwoIslesPreview = 79,
    MapJellyFishPreview = 80,
    MapGoldRushPreview = 81,
    MapIstanbulPreview = 82,
    MapEuropePreview = 83,
    MapStripesPreview = 84,
    MapMonopolyIslandsPreview = 85,

    MapSS1HeadingForNewShores3PPreview = 86,
    MapSS1HeadingForNewShores4PPreview = 87,
    MapSS1HeadingForNewShores56PPreview = 88,
    MapSS2FourIslands3PPreview = 89,
    MapSS2FourIslands4PPreview = 90,
    MapSS2SixIslands56PPreview = 91,
    MapSS3FogIslands3PPreview = 92,
    MapSS3FogIslands4PPreview = 93,
    MapSS3FogIslands56PPreview = 94,
    MapSS4ThroughTheDesert3PPreview = 95,
    MapSS4ThroughTheDesert4PPreview = 96,
    MapSS4ThroughTheDesert56PPreview = 97,

    GameMode1v1 = 98,
    GameModeBase = 99,
    GameModeBase56P = 250,
    GameModeBase78P = 251,
    GameModeSeafarers = 252,
    GameModeSeafarers56P = 253,
    GameModeCnK = 100,
    GameModeCitiesAndKnights56P = 254,
    GameModeCnKSeafarers = 248,
    GameModeSeafarersCitiesAndKnights56P = 255,
    GameModeColonistRush = 270,

    /**
     * @deprecated use GameModeBase instead
     * Remove enum once LobbyImage enums can be removed
     */
    GameModeBasePreview = 101,

    // Memberships
    StoreMembershipPlus = 102,
    StoreMembershipPremium = 103,
    StoreMembershipElite = 104,
    StoreMembershipHoliday2023 = 105,

    // Membership Perks
    StoreMembershipPerkAllMaps = 106,
    StoreMembershipPerkAllExpansions = 107,
    StoreMembershipPerkRankedGames = 108,
    StoreMembershipPerkCustomLinks = 109,
    StoreMembershipPerkColonistCoins = 110,
    StoreMembershipPerkNoAds = 111,
    StoreMembershipPerkNoAdsGifDesertBox = 112,
    StoreMembershipPerkNoAdsGifGoldBox = 113,
    StoreMembershipPerkNoAdsGifDesertHex = 114,
    StoreMembershipPerkNoAdsGifGoldHex = 115,
    StoreMembershipPerkAllColors = 116,

    // Expansions
    StoreItemExpansionClassic56P = 117,
    StoreItemExpansionClassic78P = 118,
    StoreItemSeafarers4P = 119,
    StoreItemSeafarers56P = 120,
    StoreItemCitiesAndKnights4P = 121,
    StoreItemCitiesAndKnights56P = 122,
    StoreItemCitiesAndKnightsSeafarers4P = 123,
    StoreItemCitiesAndKnightsSeafarers56P = 124,

    // Colors
    StoreColorBlack = 125,
    StoreColorPurple = 126,
    StoreColorMysticBlue = 127,
    StoreColorWhite = 128,
    StoreColorBronze = 129,
    StoreColorSilver = 130,
    StoreColorGold = 131,
    StoreColorPink = 132,

    // Icons
    IconElephant = 133,
    IconSombrero = 134,
    IconFarmer = 135,
    IconAvocado = 136,
    IconCactus = 137,
    IconCrown = 138,
    IconSwords = 139,
    IconHelmet = 140,
    IconSnorkel = 141,
    IconScarf = 142,
    IconTie = 143,
    IconWorker = 144,
    IconMummy = 145,
    IconSettlerHat = 146,
    IconColonistHat = 147,
    IconFounderHat = 148,
    IconChristmasHat = 149,
    IconPirateShip = 150,
    IconMedalGold = 151,
    IconMedalSilver = 152,
    IconMedalBronze = 153,
    IconRobberSanta = 154,
    IconRobberLunar = 155,
    IconRobberCupid = 156,
    IconGifter = 256,
    IconNoTroll = 258,

    // Packs
    SettlerPack = 157,
    ColonistPack = 158,
    FounderPack = 159,

    // Game icons
    Bank = 160,
    Robber = 161,
    Dice3Sharp = 289,
    Dice6 = 162,
    PrivateGame = 163,
    HideBankCards = 164,

    // Roads
    RoadRed = 165,
    RoadBlue = 166,
    RoadGreen = 167,
    RoadOrange = 168,
    RoadBlack = 169,
    RoadSilver = 170,
    RoadGold = 171,
    RoadWhite = 172,
    RoadPurple = 173,
    RoadMysticBlue = 174,
    RoadPink = 175,

    // Settlements
    SettlementRed = 176,
    SettlementBlue = 177,
    SettlementGreen = 178,
    SettlementOrange = 179,
    SettlementBlack = 180,
    SettlementSilver = 181,
    SettlementGold = 182,
    SettlementWhite = 183,
    SettlementPurple = 184,
    SettlementMysticBlue = 185,
    SettlementPink = 186,

    // Cities
    CityRed = 187,
    CityBlue = 188,
    CityGreen = 189,
    CityOrange = 190,
    CityBlack = 191,
    CitySilver = 192,
    CityGold = 193,
    CityWhite = 194,
    CityPurple = 195,
    CityMysticBlue = 196,
    CityPink = 197,

    // Coin Stacks
    CoinStack1 = 198,
    CoinStack2 = 199,
    CoinStack3 = 200,
    CoinStack4 = 201,
    CoinStack5 = 202,
    CoinStack6 = 203,

    // Friends
    Friends = 204,
    AddFriend = 266,

    // Login
    GoogleIcon = 205,
    AppleIcon = 206,
    DiscordIcon = 207,
    FacebookIcon = 208,

    // Rank divisions
    RankBronze = 209,
    RankSilver = 210,
    RankGold = 211,
    RankPlatinum = 212,
    RankDiamond = 213,
    RankMaster = 214,
    RankGrandmaster = 215,
    RankSubdivisionI = 216,
    RankSubdivisionII = 217,
    RankSubdivisionIII = 218,
    RankSubdivisionIV = 219,
    RankSubdivisionV = 220,

    // Mobile
    /**
     * @deprecated Layout orientation features removed
     * Remove enum once LobbyImage enums can be removed
    */
    LandscapeIcon = 221,
    /**
     * @deprecated Layout orientation features removed
     * Remove enum once LobbyImage enums can be removed
   */
    PortraitIcon = 222,

    // ColonistPack, RoadColonist, CityColonist,
    // FounderPack, RoadFounder, CityFounder,
    // RoadRed, CityRed,
    // RoadBlue, CityBlue,
    // RoadGreen, CityGreen,
    // RoadOrange, CityOrange,

    RewindToStart = 223,
    Rewind = 224,
    Play = 225,
    Pause = 226,
    FastForward = 227,
    FastForwardToEnd = 228,
    X05 = 229,
    X1 = 230,
    X2 = 231,
    X4 = 232,
    X8 = 233,

    DownArrowBlack = 265,
    DownArrow = 234,
    UpArrow = 235,
    OutArrow = 286,

    LongestRoad = 236,
    LargestArmy = 237,

    CardMonopoly = 238,
    CardVictoryPoint = 239,

    // Profile
    ProfileOverview = 240,
    ProfileRanked = 241,
    ProfileHistory = 242,
    ProfileItems = 243,
    ProfileMemberships = 269,
    ProfileSettings = 244,

    // Gifting
    StoreGiftMembership = 245,
    StoreGiftMembershipDark = 249,

    // Tournaments
    TournamentCC25 = 283,
    TournamentS11First = 257,
    Tournament4P = 260,

    // Ads
    BannerMember = 259,
    BannerShuffle = 282,
    LandscapeDeprecationWarning = 268,

    // Shuffle Icons
    IconRotation = 271,
    IconTimer = 272,
    GameModeShuffle = 273,
    // GameModeShuffleBeta = 274,

    // Beta Icons
    IconBeta = 275,

    // Bot Difficulty Icons
    BotBeginner = 276,
    BotEasy = 277,
    BotMedium = 278,
    BotHard = 279,

    // Ranked Game Mode Icons
    GameModeRanked1v1 = 280,
    GameModeRanked4P = 281,

    // Leaderboard
    Leaderboard = 284,

    // Gift
    Gift = 287,
}

// TODO: Membership Check
// Membership Types
// persisted enum, do not delete or change existing entries
export enum ColonistMembershipType {
    PlusMonthly = 0,
    PremiumMonthly = 1,
    EliteMonthly = 2,
    PlusYearly = 3,
    PremiumYearly = 4,
    EliteYearly = 5,
    Holiday2023AllAccessPass = 6,
}

// better memberships have lower values
export const COLONIST_MEMBERSHIP_PRIORITY: Record<ColonistMembershipType, number> = {
    [ColonistMembershipType.EliteYearly]: 0,
    [ColonistMembershipType.EliteMonthly]: 1,
    [ColonistMembershipType.Holiday2023AllAccessPass]: 2,
    [ColonistMembershipType.PremiumYearly]: 3,
    [ColonistMembershipType.PremiumMonthly]: 4,
    [ColonistMembershipType.PlusYearly]: 5,
    [ColonistMembershipType.PlusMonthly]: 6,
}

// persisted enum, do not delete or change existing entries
export enum ColonistOneTimePurchaseType {
    Holiday2023AllAccessPass = 0,
    GiftPlusMonthly = 1,
    GiftPremiumMonthly = 2,
    GiftEliteMonthly = 3,
    GiftPlusYearly = 4,
    GiftPremiumYearly = 5,
    GiftEliteYearly = 6,
}

// Never change or remove existing values, these are saved in the database as integers (ItemEntity.ts)
// Ok to add values to the end
// Ok to rename
export enum StoreExpansionType {
    Seafarers4P = 0,
    CitiesAndKnights4P = 1,
    TradersAndBarbarians = 2,
    ExplorersAndPirates = 3,
    Classic56P = 4,
    Classic78P = 5,
    Seafarers56P = 6,
    CitiesAndKnights56P = 7,
    CitiesAndKnightsSeafarers4P = 8,
    CitiesAndKnightsSeafarers56P = 9,
    ColonistRush4P = 10,
    // Player910,
    // Player2v2,
    // Multicatan,
    // SuperHostPowers,
    // CustomSettings,
}
